export const SalesReport = () => {
    return (
        <>Sales Report</>
    )
}